import { ReactElement } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import ChartComponent from "./ChartComponent";
import { LargeShareholderTable } from './LargeShareholderTable'
import { StatusSharesTable } from './StatusSharesTable'
import { ChartAnnotation } from '@/components/elements/ChartAnnotation'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { AHeading } from '@/components/layouts/Ir/Heading'
import { AnotationText } from '@/components/layouts/Ir/Mpocket/AnotationText'

import type { StockSituation,StockSituationOwnership,stockSituationPrincipal } from '@/types/stockSituation'

// import { useMpocketScript } from '@/hooks/useMpocketScript'

type Props = {
  stockSituation: StockSituation[],
  stockSituationOwnership:StockSituationOwnership[],
  stockSituationPrincipal:stockSituationPrincipal[]
}
export const SituationPage = ({ stockSituation,stockSituationOwnership,stockSituationPrincipal }: Props) => {
  // useMpocketScript('//irpocket.com/141A/irpocket/ir-stock-situation_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-stock-situation.js')

  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Stock Situation"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      {/* <p>This page will be available after the Ordinary General Meeting of Shareholders.</p> */}
      <Spacer h={{ sp: 70, pc: 120 }} />
      <AHeading>Shares of Common Stock</AHeading>
      <PublicationDate>{formatDate(stockSituation[0].statusSharesDate)}</PublicationDate>
      <Spacer h={{ sp: 6, pc: 10 }} />
      <StatusSharesTable items={stockSituation} />
      <Spacer h={{ sp: 50, pc: 80 }} />
      <AnotationText dangerouslySetInnerHTML={{__html: stockSituation[0].statusSharesFootnotes_en}}></AnotationText>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <AHeading>Ownership Breakdown</AHeading>
      <PublicationDate>{formatDate(stockSituationOwnership[0].OwnershipBreakdownDate)}</PublicationDate>
      <OwnerChart>
        {/* <CircleChart id="irp-highchart-situation2_en-container" /> */}
        <ChartComponent items={stockSituationOwnership} />
        <Legend id="irp-highlight-table-situation3_en" />
      </OwnerChart>
      <Spacer h={{ sp: 70, pc: 80 }} />
      <AHeading>Principal Shareholders</AHeading>
      <PublicationDate>{formatDate(stockSituationPrincipal[0].LargeShareholderDate)}</PublicationDate>
      <Spacer h={{ sp: 6, pc: 10 }} />
      <LargeShareholderTable items={stockSituationPrincipal} />
      <AnotationText dangerouslySetInnerHTML={{__html: stockSituationPrincipal[0].principalShareholdersFootnotes_en}}></AnotationText>
    </Layout>
  )
}

const formatDate = (date: string | Date) => {
  return new Date(date).toLocaleDateString("en-US", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

SituationPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Stock Information', path: '/en/ir/stock' },
    { name: 'Stock Situation', path: '' },
  ]

  return (
    <>
      <Head
        title="Stock Situation"
        description="Number of shares issued and number of shareholders."
        ogp={{ url: 'en/ir/stock/situation' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const OwnerChart = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
  }
`

const Legend = styled.div`
  tr::before {
    content: '';
    display: inline-block;
    height: 1rem;
    width: 1rem;
    vertical-align: -2px;
  }

  tr:first-of-type::before {
    background-color: ${theme.colors.chart.owner.bank};
  }

  tr:nth-of-type(2)::before {
    background-color: ${theme.colors.chart.owner.financialInstrumentsDealer};
  }

  tr:nth-of-type(3)::before {
    background-color: ${theme.colors.chart.owner.otherCorporation};
  }

  tr:nth-of-type(4)::before {
    background-color: ${theme.colors.chart.owner.foreignCorporation};
  }

  tr:nth-of-type(5)::before {
    background-color: ${theme.colors.chart.owner.treasuryStock};
  }

  tr:nth-of-type(6)::before {
    background-color: ${theme.colors.chart.owner.individual};
  }

  th {
    text-align: left;
    padding: 1rem;
    position: relative;

    ::after {
      content: ':';
      position: absolute;
      right: 0;
      display: inline-block;
    }
  }

  td:first-of-type {
    text-align: right;
    padding: 1rem;
  }
`

const PublicationDate = styled(ChartAnnotation)`
  text-align: right;
`
